export default {
  'user_management.title': 'Quản lý người dùng',
  'user_management.headerTitle': 'Danh sách người dùng quản trị',
  'user_management.username': 'Tên đăng nhập',
  'user_management.email': 'Email',
  'user_management.fullName': 'Họ tên',
  'user_management.role': 'Vai trò',
  'user_management.status': 'Trạng thái',
  'user_management.lastLogin': 'Đăng nhập lần cuối',
  'user_management.createdAt': 'Ngày tạo',
  'user_management.action': 'Thao tác',
  'user_management.edit': 'Sửa',
  'user_management.delete': 'Xóa',
  'user_management.create': 'Tạo tài khoản',
  'user_management.createTitle': 'Tạo tài khoản mới',
  'user_management.editTitle': 'Chỉnh sửa tài khoản',
  'user_management.cancel': 'Hủy',
  'user_management.password': 'Mật khẩu',
  'user_management.password.new': 'Mật khẩu mới',
  'user_management.noRole': 'Chưa có vai trò',
  'user_management.placeholder.username': 'Nhập tên đăng nhập',
  'user_management.placeholder.email': 'Nhập email',
  'user_management.placeholder.password': 'Nhập mật khẩu',
  'user_management.placeholder.password.new': 'Nhập mật khẩu mới (để trống nếu không đổi)',
  'user_management.placeholder.fullName': 'Nhập họ tên (tùy chọn)',
  'user_management.placeholder.role': 'Chọn vai trò',
  'user_management.placeholder.status': 'Chọn trạng thái',
  'user_management.rule.username.required': 'Vui lòng nhập tên đăng nhập!',
  'user_management.rule.username.min': 'Tên đăng nhập phải có ít nhất 3 ký tự!',
  'user_management.rule.email.required': 'Vui lòng nhập email!',
  'user_management.rule.email.invalid': 'Email không hợp lệ!',
  'user_management.rule.password.required': 'Vui lòng nhập mật khẩu!',
  'user_management.rule.password.min': 'Mật khẩu phải có ít nhất 6 ký tự!',
  'user_management.rule.role.required': 'Vui lòng chọn ít nhất một vai trò!',
  'user_management.rule.status.required': 'Vui lòng chọn trạng thái!',
  'user_management.status.all': 'Tất cả',
  'user_management.status.active': 'Hoạt động',
  'user_management.status.inactive': 'Không hoạt động',
  'user_management.status.suspended': 'Bị khóa',
  'user_management.confirmDelete': 'Xác nhận xóa',
  'user_management.confirmDeleteDesc': 'Bạn có chắc chắn muốn xóa tài khoản "{username}"?',
  'user_management.permissionDenied': 'Bạn không có quyền thực hiện thao tác này!',
  'user_management.roleConstraint.viewerOnly': 'Bạn chỉ được thao tác với tài khoản Viewer!',
  'user_management.createSuccess': 'Tạo tài khoản thành công!',
  'user_management.createFailed': 'Tạo tài khoản thất bại!',
  'user_management.updateSuccess': 'Cập nhật tài khoản thành công!',
  'user_management.updateFailed': 'Cập nhật tài khoản thất bại!',
  'user_management.deleteSuccess': 'Xóa tài khoản thành công!',
  'user_management.deleteFailed': 'Xóa tài khoản thất bại!',
  'user_management.errorOccurred': 'Có lỗi xảy ra!',
};
